var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'cz2__renderer',
        `cz2__renderer--${_vm.screenLocation}`,
        {
            'cz2__renderer--started': true || _vm.isStarted,
            'cz2__renderer--kiosk': _vm.isKiosk,
        },
    ],style:(_vm.placeholderBasedStyle),attrs:{"id":"cz2__renderer"}},[_c('div',{key:'controller',staticClass:"cz2__renderer__body"},[_c('renderer-image',{attrs:{"controller":_vm.currentController,"view":_vm.currentView,"onlyController":_vm.viewController}})],1),_c('transition',{attrs:{"name":"cz2__fade"}},[(_vm.show360Controls)?_c('renderer-controls'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }